import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "content",
    "fade",
    "readMoreButton",
    "readLessButton"
  ]

  connect() {
    this.minimize()
  }

  minimize() {
    this.contentTarget.style.maxHeight = this.element.dataset.maxHeight

    this.fadeTarget.classList.remove("hidden")

    if (this.hasReadMoreButtonTarget) {
      this.readMoreButtonTarget.classList.remove("hidden")
    }

    if (this.hasReadLessButtonTarget) {
      this.readLessButtonTarget.classList.add("hidden")

    }
  }

  maximize() {
    this.contentTarget.style.maxHeight = "none"

    this.fadeTarget.classList.add("hidden")

    if (this.hasReadMoreButtonTarget) {
      this.readMoreButtonTarget.classList.add("hidden")
    }

    if (this.hasReadLessButtonTarget) {
      this.readLessButtonTarget.classList.remove("hidden")
    }
  }

  toggle() {
    this.isExpanded = !this.isExpanded

    if (this.isExpanded) {
      this.minimize()
    } else {
      this.maximize()
    }
  }
}
